import { createPaginator } from "@smithy/core";
import { ListExperimentsCommand, } from "../commands/ListExperimentsCommand";
import { EvidentlyClient } from "../EvidentlyClient";
export const paginateListExperiments = createPaginator(EvidentlyClient, ListExperimentsCommand, "nextToken", "nextToken", "maxResults");
